import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { ServiceCopy } from '../types/copy';
interface ServiceCardProps {
  service: ServiceCopy;
  image: string;
  learnMore: string;
  onOpen: () => void;
}
export function ServiceCard({
  service,
  image,
  learnMore,
  onOpen
}: ServiceCardProps) {
  return <article className="group relative flex h-full flex-col overflow-hidden rounded-[24px] bg-white transition-[transform,box-shadow] duration-300 ease-[cubic-bezier(0.23,1,0.32,1)] hover:-translate-y-1 hover:shadow-[0_28px_48px_-30px_rgba(30,27,75,0.45)]" data-id="element-311" data-mp="2vkcpz3g36afg">
      <div className="aspect-[4/3] overflow-hidden bg-mist" data-id="element-312" data-mp="39apyb6ww3r5b">
        <img src={image} alt={service.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-313" data-mp="39b9h0pud6jke" />
      </div>
      <div className="flex flex-1 flex-col p-7" data-id="element-314" data-mp="3j72pny4ypsww">
        <h3 className="font-display text-[20px] font-medium leading-snug text-ink" data-id="element-315" data-mp="3o91u7bcfuvvf">
          {service.title}
        </h3>
        <p className="mt-3 text-[15.5px] leading-[1.75] text-muted" data-id="element-316" data-mp="24bd7usa14xy7">{service.description}</p>
        <div className="mt-auto pt-6" data-id="element-317" data-mp="1z94f9x12jxwm">
          <button type="button" onClick={onOpen} aria-haspopup="dialog" className="inline-flex min-h-[44px] items-center gap-2 text-[14px] font-semibold text-violet after:absolute after:inset-0 after:content-['']" data-id="element-318" data-mp="1ubmfox8xyv1a">
            {learnMore}
            <span className="sr-only" data-id="element-319" data-mp="2i16z1h90bub3">: {service.title}</span>
            <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5" data-id="element-320" data-mp="2i1qhr06hemq6" />
          </button>
        </div>
      </div>
    </article>;
}